import "./ClientNotesComponent.scss";
import template from "./ClientNotesComponent.html";
import {IComponentOptions, IOnDestroy} from "angular";
import {Observable, ReplaySubject} from "rxjs";
import {ClientNotesService} from "./service/ClientNotesService";
import {ClientNotesViewStore} from "./store/ClientNotesViewStore";
import {ClientNotesViewModel, ClientNotesViewModels} from "./models/ClientNotesViewModel";

export const ClientNotes = "tfClientNotes";

export function clientNotes(): IComponentOptions {
    return {
        template,
        bindings: {
            accountId: "<"
        },
        controllerAs: "ctrl",
        controller: ClientNotesComponentController
    };
}

export class ClientNotesComponentController implements IOnDestroy {

    /** @input */
    public set accountId(accountId: number | null) {
        if (accountId != null) {
            this.store.updateAccountId(accountId);
        }
    }

    public readonly models$: Observable<ClientNotesViewModels>;

    private readonly store: ClientNotesViewStore;

    private readonly destroyed$ = new ReplaySubject<boolean>(1);

    /** @ngInject */
    public constructor(clientNotesService: ClientNotesService) {
        this.store = new ClientNotesViewStore(clientNotesService);
        this.models$ = this.store
                           .notes
                           .map((records) => records.map((r) => ClientNotesViewModel.of(r)));
    }

    public addNote(content: string, noteTag: string) {
        this.store.addNote(content, noteTag);
    }

    public updateNote(noteId: number, content: string, noteTag: string) {
        this.store.editNote(noteId, content, noteTag);
    }

    public $onDestroy(): void {
        this.destroyed$.next(true);
        this.destroyed$.complete();
    }

    public noteTypes: string[] = ['Advice','Order','Portfolio Review','Others'];
}
